import { WS_URL } from '../config.js';
import { Realtime } from './realtimeClient.mjs';

// The game's one session socket (class and pause/resume in realtimeClient.mjs).
export const realtime = new Realtime(WS_URL);
